import { render, staticRenderFns } from "./HeaderV2UserAvatarAtom.vue?vue&type=template&id=1c89a1e0&scoped=true&"
import script from "./HeaderV2UserAvatarAtom.vue?vue&type=script&lang=ts&"
export * from "./HeaderV2UserAvatarAtom.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderV2UserAvatarAtom.vue?vue&type=style&index=0&id=1c89a1e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c89a1e0",
  null
  
)

export default component.exports